// import React, { useState, useEffect, useRef } from "react";
// import FormSide from "../../components/services-details/FormSide";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { ChevronDownIcon } from "@heroicons/react/24/outline";
// import AOS from "aos";
// import "aos/dist/aos.css";
// const SubSubServiceDetails = () => {
//   const [subsubservice, setSubsubservice] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState(0);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const sectionRefs = useRef([]);
//   const tabsContainerRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const { id } = useParams();
  
//     useEffect(() => {
//       AOS.init({ duration: 1000 });
//       window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
//     }, []);
    
//   useEffect(() => {
//     const fetchSubSubService = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/subsubservices/get-subsubservice-by-id/${id}`
//         );
//         setSubsubservice(response.data?.data || null);
//       } catch (error) {
//         console.error("Error fetching sub-subservice:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (id) fetchSubSubService();
//     else setLoading(false);
//   }, [id]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (!subsubservice?.overview?.length) return;

//     const options = { root: null, rootMargin: "0px", threshold: 0.5 };
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const index = sectionRefs.current.findIndex((ref) => ref === entry.target);
//           if (index !== -1) setActiveTab(index);

//           const tabElement = document.getElementById(`tab-${index}`);
//           if (tabElement && tabsContainerRef.current) {
//             const container = tabsContainerRef.current;
//             const tabRect = tabElement.getBoundingClientRect();
//             const containerRect = container.getBoundingClientRect();
//             if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
//               tabElement.scrollIntoView({ behavior: "smooth", inline: "center" });
//             }
//           }
//         }
//       });
//     }, options);

//     sectionRefs.current.forEach((ref) => ref && observer.observe(ref));
//     return () => sectionRefs.current.forEach((ref) => ref && observer.unobserve(ref));
//   }, [subsubservice]);

//   const scrollToSection = (index) => {
//     if (sectionRefs.current[index]) {
//       sectionRefs.current[index].scrollIntoView({ behavior: "smooth" });
//       setActiveTab(index);
//       setShowDropdown(false);
//     }
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="text-xl">Loading service details...</div>
//       </div>
//     );

//   if (!subsubservice)
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="text-xl text-red-500">Service not found</div>
//       </div>
//     );

//   return (
//     <div className="bg-gray-50">
//       <div className="container mx-auto px-4 md:px-10 py-8">
//         <div className="flex flex-col lg:flex-row gap-8">
//           {/* LEFT: Main Content */}
//           <div className="w-full lg:w-2/3">
//             <div className="">
//               <h1 className="text-2xl md:text-4xl font-semibold text-gray-800 mb-4">
//                 {subsubservice.title}
//               </h1>

//               <div className="mb-4">
//                 {subsubservice.description?.map((desc, i) => (
//                   <p
//                     key={i}
//                     className="text-gray-600 text-lg leading-relaxed space-y-3 text-justify"
//                     dangerouslySetInnerHTML={{ __html: desc }}
//                   />
//                 ))}
//               </div>


//               {subsubservice.images?.length > 0 && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//                   {subsubservice.images.map((img, i) => (
//                     <div key={i} className="overflow-hidden">
//                       <img
//                         src={img}
//                         alt={`${subsubservice.subsubserviceName || "Service"} ${i + 1}`}
//                         className="w-full h-64 object-cover"
//                       />
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* RIGHT: Form */}
//           <div className="w-full lg:w-1/3">
//             <div className="sticky top-6 ">
//               <FormSide />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Overview Section */}
//       {subsubservice.overview?.length > 0 && (
//         <div className="w-full shadow-md mt-5 md:mt-10 px-4 md:px-10">
//           <div
//             ref={tabsContainerRef}
//             className="sticky top-[4.3rem] md:top-[3rem] z-30 bg-white border-b shadow-sm overflow-x-auto flex scrollbar-hide"
//           >
//             {/* Mobile Dropdown */}
//              <div className="md:hidden w-full px-3" ref={dropdownRef}>
//               <button
//                 onClick={() => setShowDropdown(!showDropdown)}
//                 className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg flex justify-between items-center font-semibold"
//               >
//                 <span>{subsubservice.overview[activeTab]?.name || "Select Section"}</span>
//                 <ChevronDownIcon className={`h-5 w-5 ${showDropdown ? "rotate-180" : ""}`} />
//               </button>

//               {showDropdown && (
//                 <div className="bg-white shadow-lg rounded-lg mt-2 border p-2 space-y-1">
//                   {subsubservice.overview.map((item, index) => (
//                     <button
//                       key={index}
//                       onClick={() => scrollToSection(index)}
//                       className={`w-full text-left p-3 rounded-md font-medium transition ${activeTab === index
//                         ? "bg-orange-100 text-orange-700"
//                         : "text-gray-700 hover:bg-gray-100"
//                         }`}
//                     >
//                       {item.name}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Desktop Tabs */}
//             <div className="hidden md:flex gap-2 px-4 py-3">
//               {subsubservice.overview.map((item, index) => (
//                 <button
//                   id={`tab-${index}`}
//                   key={index}
//                   onClick={() => scrollToSection(index)}
//                   className={`px-6 py-3 rounded-lg text-lg font-semibold whitespace-nowrap transition-all ${activeTab === index
//                     ? "bg-orange-500 text-white shadow-inner rounded-md"
//                     : "text-gray-700 hover:bg-orange-200"
//                     }`}
//                 >
//                   {item.name}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Tab Content */}
//           <div className="container mx-auto px-4 md:px-10 mt-10 space-y-16">
//             {subsubservice.overview.map((item, index) => (
//               <section
//                 key={index}
//                 ref={(el) => (sectionRefs.current[index] = el)}
//                 className="scroll-mt-24"
//               >
//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
//                   <div>
//                     {item.title && (
//                       <h2 className="text-3xl font-bold text-gray-800">
//                         {item.title}
//                       </h2>
//                     )}

//                     {item.description?.map((desc, i) => (
//                       <p
//                         key={i}
//                         className="space-y-3 text-lg text-gray-700 leading-relaxed text-justify"
//                         dangerouslySetInnerHTML={{ __html: desc }}
//                       />
//                     ))}


//                     {item.points?.map((point, i) => (
//                       <div key={i} className="mt-4">
//                         <h3 className="text-2xl font-semibold text-gray-800">{point.heading}</h3>
//                         <p
//                           className="text-gray-700 text-lg leading-relaxed text-justify"
//                           dangerouslySetInnerHTML={{ __html: point.description }}
//                         />

//                       </div>
//                     ))}
//                   </div>

//                   {item.images?.length > 0 && (
//                     <div className="sticky top-36">
//                       <img src={item.images[0]} alt={item.name} className="w-full h-[500px] object-cover rounded-xl shadow-md" />
//                     </div>
//                   )}
//                 </div>
//               </section>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Author */}
//       {(subsubservice.authorName || subsubservice.authorDescription || subsubservice.logo) && (
//         <div className="container mx-auto px-4 md:px-10 py-10">
//           <div className="bg-gray-100 p-6 rounded-xl shadow-md">
//             <div>
//               <h2 className="text-2xl font-bold mb-2">Authors</h2>
//               {subsubservice.authorName && (
//                 <p className="text-gray-700 text-lg">
//                   Written by <span className="text-blue-600 font-semibold">{subsubservice.authorName}</span>. Last updated on{" "}
//                   {new Date(subsubservice.updatedAt).toLocaleDateString("en-US", {
//                     year: "numeric",
//                     month: "short",
//                     day: "numeric",
//                   })}{" "}
//                   {new Date(subsubservice.updatedAt).toLocaleTimeString("en-US", {
//                     hour: "2-digit",
//                     minute: "2-digit",
//                   })}
//                 </p>
//               )}
//               {subsubservice.authorDescription && (
//                 <p
//                   className="mt-3 text-gray-700 leading-relaxed text-lg text-justify"
//                   dangerouslySetInnerHTML={{ __html: subsubservice.authorDescription }}
//                 />
//               )}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SubSubServiceDetails;


import React, { useState, useEffect, useRef } from "react";
import FormSide from "../../components/services-details/FormSide";
import SEO from "../../components/common/SEO"; 
import axios from "axios";
import { useParams } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import AOS from "aos";
import "aos/dist/aos.css";

const SubSubServiceDetails = () => {
  const [subsubservice, setSubsubservice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const sectionRefs = useRef([]);
  const tabsContainerRef = useRef(null);
  const dropdownRef = useRef(null);

  const { slug, subSlug, id } = useParams();
  const identifier = slug || subSlug || id;

  //  helper to strip HTML (used for SEO fallback description, same as SubserviceDetails)
  const stripHtml = (html) => {
    if (!html) return '';
    const text = html.replace(/<[^>]*>/g, ' ');
    return text.replace(/\s+/g, ' ').trim();
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchSubSubService = async () => {
      try {
        setLoading(true);
       
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/subsubservices/get-subsubservice-by-slug/${identifier}`
        );
        setSubsubservice(response.data?.data || null);
      } catch (error) {
        console.error("Error fetching sub-subservice:", error);
        setSubsubservice(null);
      } finally {
        setLoading(false);
      }
    };

    if (identifier) fetchSubSubService();
    else setLoading(false);
  }, [identifier]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!subsubservice?.overview?.length) return;

    const options = { root: null, rootMargin: "0px", threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.findIndex((ref) => ref === entry.target);
          if (index !== -1) setActiveTab(index);

          const tabElement = document.getElementById(`tab-${index}`);
          if (tabElement && tabsContainerRef.current) {
            const container = tabsContainerRef.current;
            const tabRect = tabElement.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
              tabElement.scrollIntoView({ behavior: "smooth", inline: "center" });
            }
          }
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => ref && observer.observe(ref));
    return () => sectionRefs.current.forEach((ref) => ref && observer.unobserve(ref));
  }, [subsubservice]);

  const scrollToSection = (index) => {
    if (sectionRefs.current[index]) {
      sectionRefs.current[index].scrollIntoView({ behavior: "smooth" });
      setActiveTab(index);
      setShowDropdown(false);
    }
  };

  //  Get SEO data (same pattern as SubserviceDetails)
  const getSeoData = () => {
    if (!subsubservice) {
      return {
        title: "Sub-SubService - BBSR Services",
        description: "Professional business solutions and services",
        keywords: "BBSR Services, business solutions, subsubservice",
        canonical: "https://www.bbsrservices.co.in/sub-subservice",
      };
    }

    return {
      title: subsubservice.metaTitle || `${subsubservice.subsubserviceName} | BBSR Services`,
      description: subsubservice.metaDescription || (subsubservice.description && subsubservice.description.length > 0
        ? stripHtml(subsubservice.description[0]).substring(0, 160)
        : `${subsubservice.subsubserviceName} - BBSR Services`),
      keywords: subsubservice.metaKeywords || `${subsubservice.subsubserviceName}, BBSR Services, business solutions`,
      canonical: subsubservice.canonicalUrl || `https://www.bbsrservices.co.in/sub-subservice/${subsubservice.slug || subsubservice._id}`,
      image: subsubservice.images?.[0] || subsubservice.logo || "https://www.bbsrservices.co.in/logo.png",
    };
  };

  const seoData = getSeoData();

  if (loading)
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-xl">Loading service details...</div>
      </div>
    );

  if (!subsubservice)
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-xl text-red-500">Service not found</div>
      </div>
    );

  return (
    <>
      {/* ✅ NEW: SEO Meta Tags */}
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        image={seoData.image}
        type="article"
        author={subsubservice.authorName || "BBSR Services"}
        publishedTime={subsubservice.createdAt}
      />

      <div className="bg-gray-50">
        <div className="container mx-auto px-4 md:px-10 py-8">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* LEFT: Main Content */}
            <div className="w-full lg:w-2/3">
              <div className="">
                {/* ✅ NEW: SEO-friendly URL display, same as SubserviceDetails */}
                {/* <div className="text-sm text-gray-500 bg-white/80 px-3 py-1 rounded-lg inline-block mb-4">
                  <span className="font-medium">🔗 URL:</span> /sub-subservice/{subsubservice.slug || subsubservice._id}
                </div> */}

                <h1 className="text-2xl md:text-4xl font-semibold text-gray-800 mb-4">
                  {subsubservice.title}
                </h1>

                <div className="mb-4">
                  {subsubservice.description?.map((desc, i) => (
                    <p
                      key={i}
                      className="text-gray-600 text-lg leading-relaxed space-y-3 text-justify"
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  ))}
                </div>


                {subsubservice.images?.length > 0 && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    {subsubservice.images.map((img, i) => (
                      <div key={i} className="overflow-hidden">
                        <img
                          src={img}
                          alt={`${subsubservice.subsubserviceName || "Service"} ${i + 1}`}
                          className="w-full h-64 object-cover"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* RIGHT: Form */}
            <div className="w-full lg:w-1/3">
              <div className="sticky top-6 ">
                <FormSide />
              </div>
            </div>
          </div>
        </div>

        {/* Overview Section */}
        {subsubservice.overview?.length > 0 && (
          <div className="w-full shadow-md mt-5 md:mt-10 px-4 md:px-10">
            <div
              ref={tabsContainerRef}
              className="sticky top-[4.3rem] md:top-[3rem] z-30 bg-white border-b shadow-sm overflow-x-auto flex scrollbar-hide"
            >
              {/* Mobile Dropdown */}
              <div className="md:hidden w-full px-3" ref={dropdownRef}>
                <button
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg flex justify-between items-center font-semibold"
                >
                  <span>{subsubservice.overview[activeTab]?.name || "Select Section"}</span>
                  <ChevronDownIcon className={`h-5 w-5 ${showDropdown ? "rotate-180" : ""}`} />
                </button>

                {showDropdown && (
                  <div className="bg-white shadow-lg rounded-lg mt-2 border p-2 space-y-1">
                    {subsubservice.overview.map((item, index) => (
                      <button
                        key={index}
                        onClick={() => scrollToSection(index)}
                        className={`w-full text-left p-3 rounded-md font-medium transition ${activeTab === index
                          ? "bg-orange-100 text-orange-700"
                          : "text-gray-700 hover:bg-gray-100"
                          }`}
                      >
                        {item.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Desktop Tabs */}
              <div className="hidden md:flex gap-2 px-4 py-3">
                {subsubservice.overview.map((item, index) => (
                  <button
                    id={`tab-${index}`}
                    key={index}
                    onClick={() => scrollToSection(index)}
                    className={`px-6 py-3 rounded-lg text-lg font-semibold whitespace-nowrap transition-all ${activeTab === index
                      ? "bg-orange-500 text-white shadow-inner rounded-md"
                      : "text-gray-700 hover:bg-orange-200"
                      }`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="container mx-auto px-4 md:px-10 mt-10 space-y-16">
              {subsubservice.overview.map((item, index) => (
                <section
                  key={index}
                  ref={(el) => (sectionRefs.current[index] = el)}
                  className="scroll-mt-24"
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
                    <div>
                      {item.title && (
                        <h2 className="text-3xl font-bold text-gray-800">
                          {item.title}
                        </h2>
                      )}

                      {item.description?.map((desc, i) => (
                        <p
                          key={i}
                          className="space-y-3 text-lg text-gray-700 leading-relaxed text-justify"
                          dangerouslySetInnerHTML={{ __html: desc }}
                        />
                      ))}


                      {item.points?.map((point, i) => (
                        <div key={i} className="mt-4">
                          <h3 className="text-2xl font-semibold text-gray-800">{point.heading}</h3>
                          <p
                            className="text-gray-700 text-lg leading-relaxed text-justify"
                            dangerouslySetInnerHTML={{ __html: point.description }}
                          />

                        </div>
                      ))}
                    </div>

                    {item.images?.length > 0 && (
                      <div className="sticky top-36">
                        <img src={item.images[0]} alt={item.name} className="w-full h-[500px] object-cover rounded-xl shadow-md" />
                      </div>
                    )}
                  </div>
                </section>
              ))}
            </div>
          </div>
        )}

        {/* Author */}
        {(subsubservice.authorName || subsubservice.authorDescription || subsubservice.logo) && (
          <div className="container mx-auto px-4 md:px-10 py-10">
            <div className="bg-gray-100 p-6 rounded-xl shadow-md">
              <div>
                <h2 className="text-2xl font-bold mb-2">Authors</h2>
                {subsubservice.authorName && (
                  <p className="text-gray-700 text-lg">
                    Written by <span className="text-blue-600 font-semibold">{subsubservice.authorName}</span>. Last updated on{" "}
                    {new Date(subsubservice.updatedAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}{" "}
                    {new Date(subsubservice.updatedAt).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                )}
                {subsubservice.authorDescription && (
                  <p
                    className="mt-3 text-gray-700 leading-relaxed text-lg text-justify"
                    dangerouslySetInnerHTML={{ __html: subsubservice.authorDescription }}
                  />
                )}

              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubSubServiceDetails;